"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  var comparisonTables = document.querySelectorAll('[data-comparison-table]');
  var KEYCODE_SPACE = 32;
  if (comparisonTables.length > 0) {
    comparisonTables.forEach(function (table) {
      var selected = [0, 1];
      var expandButton = table.querySelector('[data-expand-all]'),
        sectionHead = table.querySelector('[data-section-head]'),
        sections = table.querySelectorAll('.checkbox_section'),
        sectionsFilters = table.querySelectorAll('.table_filter'),
        arias = table.querySelectorAll('[aria-expanded]'),
        tab = table.closest('.tab_panel'),
        isTabOpened = function isTabOpened() {
          return !!tab.classList.contains('checked');
        },
        toggleText = function toggleText(text) {
          return expandButton.innerHTML = text;
        },
        isTablet = function isTablet() {
          return window.innerWidth < 900;
        },
        isDesktop = function isDesktop() {
          return window.innerWidth >= 1200;
        },
        getSelected = function getSelected() {
          return selected;
        },
        setSelected = function setSelected(newValue) {
          return selected = newValue;
        };
      var toggleProduct = function toggleProduct(current) {
        var index = parseInt(current.dataset.value, 10);
        var prod = _toConsumableArray(getSelected());
        var indexOf = prod.indexOf(index);
        var count = getSelected().length;
        if (current.classList.contains('checked')) {
          if (isTablet() && count >= 2 || !isTablet() && count >= 4) {
            prod.splice(0, 1);
          }
          prod.push(index);
        } else if (count <= 2) {
          current.classList.add('checked');
        } else {
          prod.splice(indexOf, 1);
        }
        sectionsFilters.forEach(function (filter) {
          var productId = parseInt(filter.dataset.value, 10);
          var products = table.querySelectorAll('[data-product-id=\'' + productId + '\']');
          var checked = prod.indexOf(productId) !== -1;
          filter.classList.toggle('checked', checked);
          products.forEach(function (product) {
            return product.classList.toggle('show-product', checked);
          });
        });
        setSelected(prod);
      };
      var setFilters = function setFilters(selected) {
        setSelected(_toConsumableArray(selected).slice(0, isTablet() ? 2 : 4));
        sectionsFilters.forEach(function (filter) {
          var productId = parseInt(filter.dataset.value, 10);
          var products = table.querySelectorAll('[data-product-id=\'' + productId + '\']');
          var checked = productId <= getSelected().length - 1;
          filter.classList.toggle('checked', checked);
          products.forEach(function (product) {
            return product.classList.toggle('show-product', checked);
          });
        });
      };
      if (sectionsFilters.length > 0) {
        var showedProducts = Array.from(Array(sectionsFilters.length).keys());
        sectionsFilters.forEach(function (filter) {
          return filter.addEventListener('click', function () {
            return setTimeout(function () {
              return toggleProduct(filter);
            }, 100);
          });
        });
        if (sections.length > 0 && expandButton) {
          var collapse = false;
          !!expandButton.dataset.textExpand && toggleText(expandButton.dataset.textExpand);
          expandButton.addEventListener('click', function (event) {
            collapse = !collapse;
            sections.forEach(function (section) {
              return section.classList.toggle('checked', collapse);
            });
            arias.forEach(function (aria) {
              return aria.setAttribute('aria-expanded', "".concat(collapse));
            });
            if (!!expandButton.dataset.textExpand && !!expandButton.dataset.textCollapse) {
              if (collapse) {
                toggleText(event.target.dataset.textCollapse);
              } else {
                toggleText(event.target.dataset.textExpand);
              }
            }
          });
          expandButton.addEventListener('keydown', function (e) {
            if (e.key === ' ' || e.keyCode === KEYCODE_SPACE) {
              e.preventDefault();
              expandButton.click();
            }
          });
        }
        setFilters(showedProducts);
        var resetTimeout;
        window.addEventListener('resize', function () {
          clearTimeout(resetTimeout);
          resetTimeout = setTimeout(function () {
            return setFilters(showedProducts);
          }, 50);
        });
      }
      if (sectionHead.classList.contains('static')) return;
      var nav = document.querySelector('[data-secondary-nav]'),
        content = table.querySelector('[data-table-content]'),
        secondary = function secondary() {
          return nav !== null && nav !== void 0 && nav.classList.contains("sticky") && isDesktop() ? nav.offsetHeight : 0;
        },
        stickyHead = function stickyHead() {
          if (!!tab && !isTabOpened()) return;
          var tableRect = content.getBoundingClientRect();
          var headerRect = sectionHead.getBoundingClientRect();
          var isCustomSticky = sectionHead.classList.contains('custom-sticky');
          var start = tableRect.top + secondary() <= 0;
          var end = tableRect.bottom > headerRect.height + secondary();
          sectionHead.classList.toggle("sticky", start);
          isCustomSticky && start && end && sectionHead.style.setProperty('--scroll-top', "".concat(Math.abs(tableRect.top), "px"));
        };
      stickyHead();
      document.addEventListener('DOMContentLoaded', function () {
        window.addEventListener('scroll', stickyHead, {
          passive: true
        });
        window.addEventListener('resize', stickyHead, {
          passive: true
        });
      });
    });
  }
})();